var _path, _rect, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloudCalling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46,66.75A2.7528,2.7528,0,0,0,48.75,64V40A2.7528,2.7528,0,0,0,46,37.25H34A2.7528,2.7528,0,0,0,31.25,40V64A2.7528,2.7528,0,0,0,34,66.75ZM32.75,64V40A1.25116,1.25116,0,0,1,34,38.75H46A1.25116,1.25116,0,0,1,47.25,40V64A1.25116,1.25116,0,0,1,46,65.25H34A1.25116,1.25116,0,0,1,32.75,64Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 41.2998,
    width: 4,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 62,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.667,32.5835a8.87972,8.87972,0,0,0-4.49023,1.21875,17.404,17.404,0,0,0-33.251-3.80127A10.58906,10.58906,0,0,0,20,29.25a10.75,10.75,0,0,0,0,21.5h8v-1.5H20a9.25,9.25,0,0,1,0-18.5,9.1545,9.1545,0,0,1,4.01562.92773.7491.7491,0,0,0,1.03126-.41992,15.9031,15.9031,0,0,1,30.79394,3.91455.75083.75083,0,0,0,1.207.52344A7.48562,7.48562,0,0,1,61.667,34.0835a7.58325,7.58325,0,0,1,0,15.1665H52v1.5h9.667a9.08325,9.08325,0,0,0,0-18.1665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudCalling);
export default __webpack_public_path__ + "static/media/icon_cloud_calling.d80ce22e3be502f86158e63c1202d109.svg";
export { ForwardRef as ReactComponent };